import React from 'react';

const getUtilizationColor = (pct) => {
  if (pct < 50) return { bar: '#16a34a', track: '#dcfce7' };
  if (pct < 80) return { bar: '#f59e0b', track: '#fef3c7' };
  return { bar: '#dc2626', track: '#fee2e2' };
};

const formatNumber = (n) => Number(n).toLocaleString('en-IN');

const InventoryProgress = ({ purchaseQuantity, quantityRemaining }) => {
  const purchased = Number(purchaseQuantity);
  const remaining = Number(quantityRemaining);
  const consumed = Math.max(0, purchased - remaining);
  const pct = purchased > 0 ? Math.min(100, (consumed / purchased) * 100) : 0;
  const colors = getUtilizationColor(pct);

  return (
    <div style={{ minWidth: '130px', maxWidth: '180px' }}>
      <div
        style={{
          height: '7px',
          backgroundColor: colors.track,
          borderRadius: '4px',
          overflow: 'hidden',
          marginBottom: '4px',
        }}
      >
        <div
          style={{
            height: '100%',
            width: `${pct}%`,
            backgroundColor: colors.bar,
            borderRadius: '4px',
            transition: 'width 0.4s ease',
          }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ fontSize: '11px', color: '#6b7280' }}>
          {formatNumber(consumed)} / {formatNumber(purchased)} Used
        </span>
        <span style={{ fontSize: '11px', fontWeight: '600', color: colors.bar }}>
          {Math.round(pct)}%
        </span>
      </div>
    </div>
  );
};

export default React.memo(InventoryProgress);
